export const transitionQuick = "0.2s";